var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinGlassPinYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6434 16.3217C32.6434 25.3359 16.3217 47.4813 16.3217 47.4813C16.3217 47.4813 0 25.3359 0 16.3217C0 7.30747 7.30747 0 16.3217 0C25.3359 0 32.6434 7.30747 32.6434 16.3217Z",
    fill: "#EFDB22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.51782L14.9197 13.2992L13.8393 14.9197L13.8393 20.6388C13.8408 20.8407 13.9217 21.034 14.0644 21.1767C14.2072 21.3195 14.4004 21.4004 14.6023 21.4019L17.3977 21.4019C17.5996 21.4004 17.7928 21.3195 17.9356 21.1767C18.0784 21.034 18.1592 20.8407 18.1607 20.6388L18.1607 14.9197L17.0804 13.2992L17.0001 9.51792",
    stroke: "black",
    fill: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinGlassPinYellow);
export default __webpack_public_path__ + "static/media/trash-bin-glass-pin-yellow.e5946c40688a81444fd05cc0f9690855.svg";
export { ForwardRef as ReactComponent };